/** @file Playhead store: current animation, frame, playback, loop range and auto-key (PlayheadSlice). */
import { createStore } from 'zustand/vanilla';
import type { PlayheadSlice } from './types';

/**
 * Auto-key defaults on (spec §9: on by default in Animate mode). Written only through `playback/playhead` (and reset
 * by loadProject): `frame` is fractional while playing, a whole frame otherwise; `loop` is a [start, end) frame range.
 */
export const playheadStore = createStore<PlayheadSlice>()(() => ({ animation: null, frame: 0, playing: false, loop: null, autoKey: true }));
